import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { VisitorEntities } from 'client/data/models/visitor';
import { VehicleCardLoadingState } from 'client/site-modules/profile/components/shared/vehicle-card-loading-state/vehicle-card-loading-state';
import { SoldCard } from 'site-modules/profile/components/dashboard/sold-card/sold-card';
import { RegularCard } from 'site-modules/profile/components/dashboard/regular-card/regular-card';

import './vehicle-card.scss';

export function VehicleCard({
  vinData = {},
  isSubmittedLead = false,
  submittedTs = null,
  loadingInProgress,
  compareSelect = null,
  visitorLocation = null,
  isMobile = false,
  removeCard = null,
}) {
  const [isDeleted, setDeleted] = useState(false);
  const { vin, isSoldVin } = vinData;

  const onRemoveCard = useCallback(() => {
    setDeleted(true);
    removeCard(vin);
  }, [removeCard, vin]);

  return (
    <div
      className={classnames('vehicle-card h-100 mx-auto', {
        'd-none': isDeleted,
      })}
    >
      {!isSoldVin && !loadingInProgress && (
        <RegularCard
          vinData={vinData}
          submittedTs={submittedTs}
          isSubmittedLead={isSubmittedLead}
          removeCard={onRemoveCard}
          compareSelect={compareSelect}
          visitorLocation={visitorLocation}
          isMobile={isMobile}
        />
      )}
      {isSoldVin && (
        <SoldCard
          vinData={vinData}
          submittedTs={submittedTs}
          isSubmittedLead={isSubmittedLead}
          removeCard={onRemoveCard}
        />
      )}
      {loadingInProgress && <VehicleCardLoadingState />}
    </div>
  );
}

VehicleCard.propTypes = {
  vinData: PropTypes.shape({}),
  submittedTs: PropTypes.string,
  isSubmittedLead: PropTypes.bool,
  removeCard: PropTypes.func,
  loadingInProgress: PropTypes.bool.isRequired,
  compareSelect: PropTypes.shape({}),
  visitorLocation: VisitorEntities.Location,
  isMobile: PropTypes.bool,
};
